<div class="content-box d-flex flex-column item-container">
    <div class="content-header mb-3 ">
        <div class="d-flex position-relative he-box align-items-center">
            <div class="d-flex align-items-center  position-absolute left"
                *ngIf="isCourseNameCompleted && !isCourseSave">
                <i class="material-icons pe-2" (click)="onBack('course-detail')">arrow_back</i>
            </div>
            <div class="d-flex align-items-center  position-absolute left"
                *ngIf="isCourseNameCompleted && isCourseSave">
                <i class="material-icons pe-2" (click)="onBack('course-section')" *ngIf="!isViewCourse">arrow_back</i>
            </div>
            <div class="ms-5 ms-sm-auto me-auto d-flex align-items-center">
                <div class="mb-0 ms-lg-4  heading-" *ngIf="isEditCourse && !isViewCourse">Edit Course</div>
                <div class="mb-0 ms-lg-4  heading-1" *ngIf="!isEditCourse && !isViewCourse">Add Course</div>
                <div class="mb-0 ms-lg-4  heading-1" *ngIf="isViewCourse">View Course</div>
            </div>
    
            <div class="position-absolute d-flex align-items-center  justify-content-end right">
                <div class="d-block d-md-none cursor-pointer p-2" (click)="onCourseOverview('theme')"
                    *ngIf="isCourseNameCompleted && isCourseSave && !isViewCourse">
                    <img class="img-div1 me-2" src="assets/images/icons/theme_primary.svg" alt="">
                </div>
                <button class="btn btn-outline-primary  cursor-pointer th-btn d-none d-md-block"
                    (click)="onCourseOverview('theme')" *ngIf="isCourseNameCompleted && isCourseSave && !isViewCourse">
                    <img class="img-div1 me-2" src="assets/images/icons/theme_primary.svg" alt=""> Theme
                </button>
                <img class="img-div2 cursor-pointer ms-2 me-2 ms-md-4 me-md-3" (click)="onClose()"
                    src="assets/images/icons/close_icon.svg" alt="">
            </div>
        </div>
    </div>
    <div class="content-item d-flex flex-column flex-grow-1">
        <div class="row flex-grow-1 d-flex flex-column">
            <div class=" flex-grow-1 d-flex align col-12 card mb-0" *ngIf="!isCourseNameCompleted">
                <form action="" class="flex-grow-1 d-flex flex-column" [formGroup]="scratchForm"
                    (ngSubmit)="onConfirm()">
                    <div class="card-body d-flex flex-grow-1 align-items-center justify-content-center ">
                        <div class=" flex-grow-1 f-box">
                            <div class="spin-box" *ngIf="isSpinnerLoading">
                                <div class="custom-loader"></div>
                            </div>
                            <div class="drop-box m-auto  mt-4"
                                *ngIf="!scratchForm.get('img')?.value && !isSpinnerLoading" style="position:relative">
                                <ngx-dropzone class="drop-item" [multiple]="false" (change)="onSelect($event)"
                                    accept="image/jpeg,image/jpg,image/png" *ngIf="!isSpinnerLoading">
                                    <ngx-dropzone-label>
                                        <div class="d-box">
                                            <div class="me">
                                                <img src="assets/images/apps/upload_file.svg" class="img-fluid" alt="">
                                            </div>
                                            <div>
                                                <div class="text-left">Click to Upload</div>
                                                <div class="upload-text text-left">Or just drag and drop</div>
                                            </div>
                                        </div>
                                    </ngx-dropzone-label>
                        
                                </ngx-dropzone>

                            </div>
                            <div class="cursor-pointer course-img m-auto" *ngIf="scratchForm.get('img')?.value">
                                <img [src]="scratchForm.get('img')?.value" class="img-fluid">
                                <div class="action-icon me-2 del-icon delete-img" (click)="onDeleteImage()">
                                    <i class="material-icons">delete</i>
                                </div>
                            </div>
              
                            <input type="text" class="form-control mt-3 mt-lg-4" formControlName="courseName"
                                placeholder="Enter Course Title">
                            <div class="d-flex mt-3 btn-div justify-content-center" *ngIf="!isEditCourse">
                                <mat-radio-group class="mt-3 d-flex rd-box" formControlName="c_type"
                                    (change)="onCourseType($event)">
                                    <div class="d-flex">
                                        <mat-radio-button class="" value="scratch"></mat-radio-button>
                                        <div class="radio-title l-h">Start from scratch</div>
                                    </div>
                                    <div class="d-flex ms-4 rd-l" *ngIf="templateCourseArr.length >0">
                                        <mat-radio-button class="" value="template"></mat-radio-button>
                                        <div class="radio-title  l-h">Use a template</div>
                                    </div>
                                </mat-radio-group>
                            </div>
                   
                        </div>
                    </div>
                 
                </form>
            </div>
            <div class="flex-grow-1 col-12 card ps-xl-5 pe-xl-5 mb-0 d-flex"
                *ngIf="isCourseNameCompleted && !isCourseSave">

                <form action=" " [formGroup]="courseDetail" (ngSubmit)="onCourseDetailSubmit()"
                    class="flex-grow-1 d-flex flex-column">
                    <div class="card-body flex-grow-1 d-flex flex-column justify-content-lg-center c-body">
                        <div class="row flex-grow-1 justify-content-center course-detail-form">
                            <div class=" col-12 d-flex">
                                <div class="flex-grow-1 d-flex flex-column justify-content-center">
                                    <div class="row ps-xl-5 pe-xl-5">
                                        <div class="col-12 col-lg-6 pe-lg-4 d-flex flex-column ">
                                            <div class="mt-lg-3 mb-3 mb-lg-4">
                                                <label for="" class="ms-0">Department Name</label>
                                                <select name="" class="form-control" id="" formControlName="dep">
                                                    <option value="">Select Department </option>
                                                    <option [value]="item.id" *ngFor="let item of departmentArr">
                                                        {{item.dep }}</option>
                                                </select>
                                                <mat-error *ngIf="isControlHasError('dep','required')">{{"Department is  required" |translate}} </mat-error>
                                            </div>
                                            <div class="mb-2 mb-sm-3 mb-lg-4 desc flex-grow-1 d-flex flex-column"
                                                [ngClass]="isAdmin ? '':''">
                                                <div>
                                                    <label class="example-margin ms-0 mb-2">Description:</label>
                                                </div>
                                                <quill-editor [styles]="{width: '100%',height:''}"
                                                    class="d-flex flex-column flex-grow-1"
                                                    formControlName="desc"></quill-editor>
                                                <mat-error *ngIf="isControlHasError('desc','required')">{{"Description is required" |translate}} </mat-error>
                                            </div>
                                        </div>
                                        <div class="col-12 col-lg-6 ps-lg-4 ">
                                            <div class="mb-3 mb-lg-4 pt-2 pt-lg-4 mt-lg-3 d-flex flex-column">
                                                <div class="example-margin radio-title ms-0">Manual Certificate
                                                    Generation :</div>
                                                <mat-radio-group class="mt-2 d-flex" formControlName="m_c_g">
                                                    <div class="d-flex">
                                                        <mat-radio-button class="" [value]="0"></mat-radio-button>
                                                        <div class="radio-title">No</div>
                                                    </div>
                                                    <div class="d-flex ms-3">
                                                        <mat-radio-button class="" [value]="1"></mat-radio-button>
                                                        <div class="radio-title">Yes</div>
                                                    </div>
                                                </mat-radio-group>
                                            </div>
                                            <mat-error *ngIf="isControlHasError('m_c_g','required')">{{"This is  required" |translate}} </mat-error>
                                            <div class=" mb-3 pt-lg-3 ">
                                                <div class="me-5 ms-0">Exam :</div>
                                                <mat-radio-group class="mt-2 d-flex" formControlName="is_info">
                                                    <div class="d-flex">
                                                        <mat-radio-button class="" [value]="1"></mat-radio-button>
                                                        <div class="radio-title">No</div>
                                                    </div>
                                                    <div class="d-flex ms-3">
                                                        <mat-radio-button class="" [value]="0"></mat-radio-button>
                                                        <div class="radio-title">Yes</div>
                                                    </div>
                                        
                                                </mat-radio-group>
                                            </div>
                                            <mat-error *ngIf="isControlHasError('is_info','required')">{{"Exam is required" |translate}} </mat-error>
                                            <div class=" mb-3 pt-lg-3" *ngIf="courseDetail.get('is_info')?.value==0">
                                                <div class="me-3 ms-0">Exam Type:</div>
                                                <mat-radio-group class="mt-2 d-flex" formControlName="e_t">

                                                    <div class="d-flex">
                                                        <mat-radio-button class=""
                                                            [value]="'average'"></mat-radio-button>
                                                        <div class="radio-title">Section wise Exam</div>
                                                    </div>
                                                    <div class="d-flex ms-3">
                                                        <mat-radio-button class="" [value]="'final'"></mat-radio-button>
                                                        <div class="radio-title">Just Final Exam</div>
                                                    </div>

                                                </mat-radio-group>
                                            </div>
                                            <div class=" mb-3  d-flex align-items-center "
                                                *ngIf="courseDetail.get('e_t')?.value=='average'">
                                                <div class="q-input">
                                                    <input type="number" class="form-control "
                                                        placeholder="Enter Qualify Percentage "
                                                        formControlName="qualify_marks" (change)="onQualifyMark()">
                                                </div>
                                                <mat-error *ngIf="onQualifyMark()">{{"Please enter a valid number that must be between 0 and 100." |translate}} </mat-error>
                                            </div>
                                            <div class=" mb-3 pt-lg-3 ">
                                                <label class="example-margin ms-0">Certificate Expires After X Months</label>
                                         
                                                <mat-radio-group class="mt-2  d-flex"
                                                    (change)="onCertificateType($event)">
                                                    <div class="d-flex">
                                                        <mat-radio-button class="" [value]="0"
                                                            [checked]="certificateType=='never'"></mat-radio-button>
                                                        <div class="radio-title">Certificate never expires</div>
                                                    </div>
                                                    <div class="d-flex ms-3">
                                                        <mat-radio-button class="" [value]="1"
                                                            [checked]="certificateType=='expire'"></mat-radio-button>
                                                        <div class="radio-title">Certificate Expires</div>
                                                    </div>
                                                </mat-radio-group>
                                                <div class="d-flex" *ngIf="certificateType!='never'">
                                                    <div class=" month-b me-2">
                                                        <input type="number" class="form-control mt-3" placeholder="Certificate Expires After X Months"
                                                            formControlName="c_et">
                                                    </div>
                                                    <div class="ms-2">
                                                        <div class="form-control  mt-3">Month</div>
                                                    </div>
                                                </div>
                                                <mat-error *ngIf="isControlHasError('c_et','min')">{{"Please enter valid  months"|translate}} </mat-error>
                                                <mat-error *ngIf="isControlHasError('c_et','required')">{{"This is required"|translate}} </mat-error>
                                            </div>
                                            <div class=" my-3 desc" *ngIf="isAdmin">
                                                <div>
                                                    <label class="example-margin ms-0 mb-2">Price:</label>
                                                </div>
                                                <input type="number" class="form-control" placeholder="Enter amount " formControlName="pr">
                                                <mat-error *ngIf="isControlHasError('pr','required')">{{"Price is required" |translate}} </mat-error>
                                                <mat-error *ngIf="isControlHasError('pr','min')">{{" Price must be greater than 0" |translate}} </mat-error>
                                            </div>
                                            <div class=" mb-3 mb-xl-5 pt-lg-3">
                                                <label class="example-margin ms-0 pb-2">Certificate congratulation
                                                    message:</label>
                                                <textarea rows="4" cols="50" class="form-control h-auto ps-2"
                                                    formControlName="c_msg"> </textarea>
                                                <mat-error *ngIf="isControlHasError('c_msg','required')">{{"Message is  required"|translate}} </mat-error>
                                            </div>
                                        </div>
                                    </div>
                                    <mat-error *ngIf="isControlHasError('m_c_g','required')">{{"This is required" |translate}} </mat-error>
                                </div>
                            </div>
                        </div>
                    </div>
                    
                </form>
            </div>
            <div class="flex-grow-1 col-12  mb-0 d-flex flex-column" *ngIf="isCourseNameCompleted && isCourseSave">
                <div class="row flex-grow-1 scratch-div add-course-card" *ngIf="(courseType=='scratch')">
                    <div
                        class="left-col-s col-lg-7 mt-3 mt-lg-0 col-xl-8 d-flex flex-column justify-content-center align-items-center">
                        <div class="card h-100  left-container">
                            <div class="d-flex align-items-center mt-2 mb-3 mb-md-4">
                                <h6 class=" sentence-wrapper mb-0">{{scratchForm.value.courseName}}</h6>
                            </div>
                            <ng-container *ngTemplateOutlet="courseView"></ng-container>
                        </div>
                    </div>
                    <div class="col-lg-5 d-flex flex-column bg-grey6 mt-3 mt-xl-0 col-xl-4">
                        <ng-container *ngTemplateOutlet="mobileView"></ng-container>
                    </div>
                </div>
                <div class="row flex-grow-1 scratch-div add-course-card" *ngIf="(courseType=='template')  ">
                    <div class="left-col-t col-12 col-xl-3 border-r mt-xl-0  d-flex justify-content-center">
                        <div class="card  h-100 p-3 left-container1">
                            <div class="d-flex justify-content-between  flex-wrap ">
                                <div class="form-input  mb-2">
                                    <input type="text" class="form-control" placeholder="{{'Search'}}"
                                        (input)="onSearchTemp($event)">
                                    <mat-icon class="input-icon">search</mat-icon>
                                </div>
                            </div>
                            <h6 class="mb-0  mt-3 mt-lg-4 mb-xl-2" *ngIf="adminTemplateArr.length >0">Admin Template
                            </h6>
                            <div class="template-box text-black sentence-wrapper d-flex justify-content-between"
                                *ngFor="let item of adminTemplateArr" (click)="onSelectTemplate(item)"
                                [ngClass]="selectedCourse[0].t_i==item.t_i ? 'active-course' : ''">
                                <div *ngIf="selectedCourse[0].t_i!=item.t_i"> {{item.t_tit}}</div>
                                <input *ngIf="selectedCourse[0].t_i==item.t_i" type="text" [(ngModel)]="item.t_tit"
                                    class="border-0 input" (change)="onTemplateTitleChange($event)">
                            </div>
                            <h6 class="mb-0  mt-3 mt-lg-4 mb-xl-2" *ngIf="companyTemplateArr.length >0">My Creation</h6>
                            <div class="template-box text-black sentence-wrapper d-flex justify-content-between"
                                *ngFor="let item of companyTemplateArr" (click)="onSelectTemplate(item)"
                                [ngClass]="selectedCourse[0].t_i==item.t_i ? 'active-course' : ''">
                                <div *ngIf="selectedCourse[0].t_i!=item.t_i"> {{item.t_tit}}</div>
                                <input *ngIf="selectedCourse[0].t_i==item.t_i" type="text" [(ngModel)]="item.t_tit"
                                    class="border-0 input" (change)="onTemplateTitleChange($event)">
                                <div class="d-flex">
                                    <div class="action-icon me-1" >
                                        <img src="assets/images/icons/edit-icon.svg" alt="" class="img-fluid">
                                    </div>
                                    <div class="action-icon me-1" (click)="onDeleteTemplateAPI($event,item)">
                                        <img src="assets/images/icons/delete-icon.svg" alt="" class="img-fluid">
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="left-col-t col-12 col-xl-5 mt-3 mt-lg-0  d-flex justify-content-center">
                        <div class="card h-100 p-3 left-container1">
                            <div class="d-flex align-items-center mt-2  mb-3 mb-md-4">
                                <i class="material-icons pe-2" (click)="onBack('course-section')"
                                    *ngIf="!isViewCourse">arrow_back</i>
                                <h6 class=" sentence-wrapper mb-0">{{scratchForm.value.courseName}}</h6>
                            </div>
                            <ng-container *ngTemplateOutlet="courseView"></ng-container>
                        </div>
                    </div>
                    <div class="col-12 col-xl-4  mt-3 mt-xl-0  bg-grey6 d-flex justify-content-center">
                        <ng-container *ngTemplateOutlet="mobileView"></ng-container>
                    </div>
                </div>
            </div>

        </div>
    </div>
    <div class="d-box"  *ngIf="!isCourseNameCompleted">
        <button mat-raised-button color="primary" class="auth-form-btn my-3 mt-lg-5  mb-lg-5" type="submit" (click)="onConfirm()"
            [disabled]="!scratchForm.valid">Continue</button>
    </div>
    <div class="content-footer item-footer  mt-3" *ngIf="isCourseNameCompleted && !isCourseSave">
        <div class="d-flex justify-content-end align-items-center ">
            <button type="button"
                class="btn  btn-outline-primary mt-sm-3 me-2 me-sm-3 align-items-center"
                (click)="onBack('course-detail')">{{"Back" |translate}}</button>
            <button mat-raised-button color="primary" class=" mt-sm-3 " (click)="onCourseDetailSubmit()"
                type="submit">{{"Next"|translate}}</button>
        </div>
    </div>
    <div class="content-footer item-footer" *ngIf="isCourseNameCompleted && isCourseSave">
        <div class="text-center"> <mat-error *ngIf="courseError">{{courseError}}</mat-error></div>
        <div class="d-flex justify-content-end align-items-center pt-2 main-btn-cont " *ngIf="!isViewCourse">
            <button color="primary" class="btn btn-outline-primary mt-3 me-2 " type="submit"
                (click)="onSave('template')" *ngIf="!isEditCourse">
                {{courseType=='template' ? "Edit Template" :"Save as template"|translate}}</button>
            <button type="button" class="btn  ms-auto btn-outline-primary mt-3  me-2 align-items-center"
                (click)="onBack('course-section')">
                {{"Back" |translate}}</button>
            <button mat-raised-button color="primary" class=" mt-3 " type="submit"
                (click)="onSave('course')">{{"Save"|translate}}</button>
        </div>
    </div>
</div>
<ng-template #courseView>
    <mat-accordion class="custom-mat-accordion" cdkDropList (cdkDropListDropped)="mainDrop($event)"
        [cdkDropListDisabled]="isViewCourse">
        <mat-expansion-panel (opened)="panelOpenState = true" (closed)="panelOpenState = false" cdkDrag
            *ngFor="let item of courseArrName;let i=index">
            <mat-expansion-panel-header class="ti-box">
                <mat-panel-title class="se-b d-flex justify-content-between">
                    <div class=" d-flex align-items-center flex-grow-1">
                        <div class="drag-img me-3 d-none d-sm-flex ">
                            <img src="assets/images/icons/drag_drop.png" class="img-fluid" alt="">
                        </div>
                        <div class="flex-grow-1">
                            <input class="i-t" type="text" placeholder="Enter Section title" [(ngModel)]="item.s_tit"
                                [readonly]="isViewCourse" #myInput (keydown.Space)="$event.stopPropagation()"
                                (change)="onInput($event)">
                        </div>
                    </div>
                    <div class="icons-box ti-ic-b " *ngIf="!isViewCourse">
                  
                        <div class="action-icon me-2 " (click)="onCopySection($event,item)">
                            <i class="material-icons coppy-icon">content_copy</i>
                        </div>
                        <div class="action-icon me-2 " (click)="onDeleteSection($event,i)">
                            <img src="assets/images/icons/delete-icon.svg" alt="" class="img-fluid">
                        </div>
                    </div>
                </mat-panel-title>
            </mat-expansion-panel-header>
            <div class="template-content-box" cdkDropList (cdkDropListDropped)="drop(i,$event)">
                <div class="item-box d-flex" cdkDrag *ngFor="let value of item.sub_s;let j=index"
                    [cdkDragDisabled]="(j === item.sub_s.length - 1)">
                    <div class="d-flex align-items-center">
                        <div class="num-box me-2">{{j+1}}</div>
                        <div class="drag-img me-2" *ngIf="!isViewCourse"><img src="assets/images/icons/drag_drop.png"
                                class="img-fluid" alt=""></div>
                        <div class="drag-img object-icon me-2">
                            <img *ngIf="value.type=='text'" src="assets/images/object_icons/text.svg" class="img-fluid"
                                alt="">
                            <img *ngIf="value.type=='audio'" src="assets/images/object_icons/audio.svg"
                                class="img-fluid" alt="">
                            <img *ngIf="value.type=='video'" src="assets/images/object_icons/video.svg"
                                class="img-fluid" alt="">
                            <img *ngIf="value.type=='youtube'" src="assets/images/object_icons/youtube.svg"
                                class="img-fluid" alt="">
                            <img *ngIf="value.type=='pdf'" src="assets/images/object_icons/pdf.svg" class="img-fluid"
                                alt="">
                            <img *ngIf="value.type=='file'" src="assets/images/object_icons/file.svg" class="img-fluid"
                                alt="">
                            <img *ngIf="value.type=='link'" src="assets/images/object_icons/link.svg" class="img-fluid"
                                alt="">
                            <img *ngIf="value.type=='exam'" src="assets/images/object_icons/quiz.svg" class="img-fluid"
                                alt="">
                            <img *ngIf="value.type=='image'" src="assets/images/object_icons/image.svg"
                                class="img-fluid" alt="">
                            <img *ngIf="value.type=='iframe'" src="assets/images/object_icons/iframe.svg" class="img-fluid" alt="">    
                        </div>
                        <div class="clamp-line-1" *ngIf="value.sub_tit!=''">{{value.sub_tit}}</div>
                        <div class="clamp-line-1" *ngIf="value.sub_tit==''">Sub section {{j+1}}</div>
                    </div>

                    <div class="icons-box" *ngIf="!isViewCourse">
                        <div class="action-icon me-2 " (click)="onEditItem(i,j,value)">
                            <img src="assets/images/icons/edit-icon.svg" alt="" class="img-fluid">
                        </div>

                        <div class="action-icon me-2 " (click)="onCopyCourse(i,value)" *ngIf="value.type!='exam'">
                            <i class="material-icons coppy-icon">content_copy</i>
                        </div>
                        <div class="action-icon me-2 " (click)="onDeleteCourse(i,j)">
                            <img src="assets/images/icons/delete-icon.svg" alt="" class="img-fluid">
                        </div>
             
                    </div>
                </div>
                <div class="item-box d-flex cursor-pointer" (click)="onAddObject(i)" *ngIf="!isViewCourse">
                    <div class="d-flex align-items-center add-obj"> <i class="material-icons me-2 add-obj">add</i> Add
                        Object</div>
                </div>
            </div>
        </mat-expansion-panel>
        <div class="add-section d-flex align-items-center justify-content-center mt-3 mt-lg-4 mb-2" (click)="onAddSection()"
            *ngIf="!isViewCourse">
            <i class="material-icons me-2 add-obj">add</i> Add New Section
        </div>
    </mat-accordion>
</ng-template>
<ng-template #mobileView>
    <div class="d-flex justify-content-center flex-column align-items-center p-sm-3 flex-grow-1 ">
        <div class="course-ov mb-4 cursor-pointer" (click)="onCourseOverview('overview')" *ngIf="!isViewCourse">Course
            Overview</div>
        <div class="mobile-container ">
            <div class="mob-header py-3">
                <span class="sentence-wrapper mx-2" *ngIf="courseType=='scratch'">{{scratchForm.get('courseName')?.value
                    }}</span>
                <span class="sentence-wrapper mx-2"
                    *ngIf="courseType=='template'">{{selectedCourse.course_title}}</span>
                <div class="mobile-curve"><img src="assets/images/apps/mobile_header_curve.png" alt=""></div>
            </div>
            <div class="mobile-content">
                <div class="m-con-box" *ngFor="let item of courseArrName">
                    <div class="m-con-he my-2"> {{item.s_tit}}</div>
                    <div class="d-flex m-con mb-2" *ngFor="let value of item.sub_s;let i=index">
                        <div class="icons-i me-2">
                            <img *ngIf="value.type=='text'" src="assets/images/object_icons/text.svg" class="img-fluid"
                                alt="">
                            <img *ngIf="value.type=='audio'" src="assets/images/object_icons/audio.svg"
                                class="img-fluid" alt="">
                            <img *ngIf="value.type=='video'" src="assets/images/object_icons/video.svg"
                                class="img-fluid" alt="">
                            <img *ngIf="value.type=='youtube'" src="assets/images/object_icons/youtube.svg"
                                class="img-fluid" alt="">
                            <img *ngIf="value.type=='pdf'" src="assets/images/object_icons/pdf.svg" class="img-fluid"
                                alt="">
                            <img *ngIf="value.type=='file'" src="assets/images/object_icons/file.svg" class="img-fluid"
                                alt="">
                            <img *ngIf="value.type=='link'" src="assets/images/object_icons/link.svg" class="img-fluid"
                                alt="">
                            <img *ngIf="value.type=='exam'" src="assets/images/object_icons/quiz.svg" class="img-fluid"
                                alt="">
                            <img *ngIf="value.type=='image'" src="assets/images/object_icons/image.svg"
                                class="img-fluid" alt="">
                            <img *ngIf="value.type=='iframe'" src="assets/images/object_icons/iframe.svg" class="img-fluid" alt="">    
                        </div>
                        <div class="icons-c" *ngIf="value.sub_tit!=''">{{value.sub_tit}}</div>
                        <div class="icons-c" *ngIf="value.sub_tit==''">Sub section {{i+1}}</div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</ng-template>
<app-loading-spinner></app-loading-spinner>